import React from "react";
import Modal from "../../../components/My/Modal";
import {TurnstileButton} from "./Button";

const ModalSimple = ({visible, close, accept, body, title}) => {
    if (!visible) return null;
    return (
        <Modal
            body={body}
            title={title}
            visible={visible}
            close={() => close()}
            footer={<>
                <TurnstileButton text={"Zrušit"} outline={true} onClick={() => close()}/>
                <TurnstileButton text={"Potvrdit"} onClick={() => accept()}/>
            </>}
        />
    );
};

export default ModalSimple;
